import { Injectable } from '@angular/core';
import {
  GamesService,
  ListHelperService,
  ProfileService,
  StoreService,
  CountriesService,
  LocalesService
} from 'core/services';
import { TranslateService } from '@ngx-translate/core';
import { TableDatasource, DataTypes } from '@gamelearn/skeletor/models';

@Injectable()
export class GamesListService {
  userRole: any;

  constructor(
    public gamesService: GamesService,
    public translate: TranslateService,
    public profileService: ProfileService,
    public listHelper: ListHelperService,
    public countriesService: CountriesService,
    public locales: LocalesService
  ) {
    profileService.getLoggedUserRole$().subscribe((userRole) => (this.userRole = userRole));
  }

  async getDatasource(listId, options: any = {}) {
    const dataSource = new TableDatasource({
      sort: 'name',
      columns: this.getColumns(),
      load: (props) => this.fetch(props, dataSource),
      storeState: {
        enabled: true,
        key: `${listId}_${this.userRole.name}`
      },
      ...options
    });
    await dataSource.refreshData();
    StoreService.create(listId, dataSource);
    return dataSource;
  }

  fetch({ page, limit, sort, search, filters, aggregates, populate }, dataSource: TableDatasource) {
    const $filter = this.listHelper.buildFilterString(filters, dataSource, this.getCustomFilters());

    const paginationOptions = {
      page,
      limit,
      sort,
      search,
      aggregates,
      populate,
      $filter
    };
    return this.gamesService.fetch(paginationOptions).then((response) => response);
  }

  getColumns() {
    const columns = [
      {
        source: 'name',
        label: this.translate.instant('nouns.name'),
        sortable: true,
        cellRenderer: (renderer, value, game) =>
          renderer`<div class="ellipsis">${this.listHelper.getRouterLinkRenderer(
            renderer,
            `/games/${game.id}`,
            value
          )}</div>`
      },
      {
        source: 'credits',
        label: this.translate.instant('nouns.credits'),
        sortable: true
      },

      {
        source: 'clientName',
        label: this.translate.instant('nouns.client'),
        sortable: false
      },
      {
        source: 'hours',
        label: this.translate.instant('games.duration'),
        sortable: true
      },
      {
        source: 'disabled',
        label: this.translate.instant('games.properties.disabled'),
        dataType: DataTypes.boolean,
        sortable: true,
        allowFiltering: false
      }
    ];
    return columns;
  }

  getCustomFilters() {
    return {};
  }
}
